import React from "react";

export const useInsertionEffect = React.useInsertionEffect
  ? React.useInsertionEffect
  : false;

export const useInsertionEffectWithLayoutFallback =
  useInsertionEffect || React.useLayoutEffect;
